import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';
import '../../common/bn-loading';

class BinIssueStateLevelFormHeight extends BinIssueStateMixin(LitEntity) {
  constructor() {
    super();
    this.collectedFields = ['correctedLevelHeight'];
  }

  static get styles() {
    return [...super.styles, css`
      :host {
        align-items: center;
      }
      bin-profile {
        pointer-events: none;
        height: 35vh;
        max-height: 250px;
        max-width: 150px;
        flex-shrink: 4;
        width: 20vh;
      }
      input[type=range] {
        writing-mode: bt-lr;
        transform: rotate(270deg);
        width: 35vh;
        height: 40vh;
        max-width: 250px;
        margin: 0px -7vh;
      }
      .row {
        justify-content: center;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    const feedHeight = this.data.correctedLevelHeight === undefined ? this.data.selectedLevelHeight : this.data.correctedLevelHeight;
    const feedHeightPercentage = feedHeight / this.entity.properties.dimensions.totalHeight;
    return html`
      <div class="flex col bin-level-select">
        <h2>Please Correct the Feed Level</h2>
        <div class="flex row">
          <input
            type="range"
            orient="vertical"
            value="${Math.round(feedHeightPercentage * 100)}"
            @input="${this._onChangeRange}"
          />
          <bin-profile
            .href="${this.href}"
            .level="${{ feedHeight }}"
            ignore-latest-level
          ></bin-profile>
        </div>
      </div>
      ${this.renderNext()}
    `;
  }

  _hasData() {
    return !!this.entity && this.data.correctedLevelHeight !== undefined;
  }

  updated() {
    this.stateHasData = this._hasData();
  }

  _onChangeRange(e) {
    const levelFixedDigits = ((e.target.value / 100) * this.entity.properties.dimensions.totalHeight).toFixed(9);
    this.data.correctedLevelHeight = Number(levelFixedDigits);
    this.stateHasData = this._hasData();
    this.requestUpdate();
  }
}

window.customElements.define('bin-issue-state-level-form-height', BinIssueStateLevelFormHeight);
